import React, {createContext, useContext} from 'react'
import Shepherd from 'shepherd.js'

type Props = Readonly<{
  name: string
  tour: Shepherd.Tour | null
  children: React.ReactNode
}>

const TourNameContext = createContext<string | null>(null)
const TourContext = createContext<Shepherd.Tour | null>(null)

function TourProvider({name, tour, children}: Props): JSX.Element {
  return (
    <TourNameContext.Provider value={name}>
      <TourContext.Provider value={tour}>{children}</TourContext.Provider>
    </TourNameContext.Provider>
  )
}

export function useTour(): Shepherd.Tour | null {
  return useContext(TourContext)
}

export function useTourName(): string | null {
  return useContext(TourNameContext)
}

export default TourProvider
